module.exports = __webpack_public_path__ + "fonts/iconfont.08b1fc4.woff2";